import { render, staticRenderFns } from "./TicTacToe.vue?vue&type=template&id=727ac9d2&scoped=true&"
import script from "./TicTacToe.vue?vue&type=script&lang=js&"
export * from "./TicTacToe.vue?vue&type=script&lang=js&"
import style0 from "./TicTacToe.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TicTacToe.vue?vue&type=style&index=1&id=727ac9d2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727ac9d2",
  null
  
)

export default component.exports